import { useState } from "react";
import { Check, ChevronDown, Star } from "lucide-react";
import { IMAGES, TESTIMONIALS, FAQ, LINKS, onImgErr } from "./data";
import "./App.css";

const PACKAGE = [
  "Powieść w 30 rozdziałach (żywy hiszpański A1/A2)",
  "Audiobook nagrany przez rodowitą Hiszpankę",
  "Zeszyt ćwiczeń z kluczem odpowiedzi",
  "Pełne tłumaczenie na polski i słowniczki",
  "Kalendarz czytania na 30 dni",
  "Dostęp natychmiast na stronie po zakupie — bez czekania na e-mail",
];

const NOTE_TOP = "Cena promocyjna 55€ zamiast 65€ • Płatność jednorazowa, bez subskrypcji";
const NOTE_BOTTOM = "Cena specjalna 55€ do 21 października • Płatność jednorazowa";
const TRUST = "Bezpieczna płatność przez Stripe • Dostęp bezterminowy • Dostęp natychmiast na stronie po płatności";

const BuyButton = ({ testid }) => (
  <button
    type="button"
    className="lp-btn"
    data-testid={testid}
    onClick={() => { window.location.href = LINKS.checkout; }}
  >
    KUPUJĘ I ODBIERAM DOSTĘP — 55€
  </button>
);

const PriceBlock = ({ testid, note }) => (
  <div className="lp-price-wrap" data-testid={testid}>
    <div className="lp-price">
      <span className="lp-price-old">65&nbsp;€</span>
      <span className="lp-price-now">55&nbsp;€</span>
    </div>
    <p className="lp-offer-note">{note}</p>
  </div>
);

const FaqItem = ({ q, a, i }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`lp-faq-item ${open ? "is-open" : ""}`} data-testid={`faq-item-${i}`}>
      <button
        type="button"
        className="lp-faq-q"
        onClick={() => setOpen((v) => !v)}
        data-testid={`faq-q-${i}`}
        aria-expanded={open}
      >
        <span>{q}</span>
        <ChevronDown className="lp-faq-chev" size={20} />
      </button>
      <div className="lp-faq-a" style={{ maxHeight: open ? 400 : 0 }}>
        <p>{a}</p>
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="lp" data-testid="landing">
      <main className="lp-wrap">

        {/* HERO */}
        <section className="lp-hero" data-testid="hero">
          <h1 className="lp-title" data-testid="hero-title">
            Twoja pierwsza książka po hiszpańsku <em>(A1/A2)</em> — zrozum prawdziwy hiszpański bez wkuwania gramatyki
          </h1>
          <p className="lp-sub" data-testid="hero-subtitle">
            30 opowiadań żywego języka + audiobook nativo + ćwiczenia. Czytaj i rozumiej Hiszpanów już od pierwszego rozdziału.
          </p>
          <div className="lp-cover lp-flip" data-testid="flipbook">
            <h2 className="lp-flip-h">Przejrzyj fragment</h2>
            <iframe
              title="Przejrzyj fragment — Un nuevo comienzo"
              allowFullScreen
              allow="autoplay; fullscreen; clipboard-write"
              scrolling="no"
              src="https://heyzine.com/flip-book/0ca19df65d.html"
              data-testid="flipbook-iframe"
            />
          </div>
          <figure className="lp-hero-quote" data-testid="hero-testimonial">
            <div className="lp-stars" aria-label="5/5">
              {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={16} fill="currentColor" />)}
            </div>
            <blockquote>„Pierwszy raz czytam po hiszpańsku i nie odpuszczam po jednej stronie. Historia naprawdę wciąga!”</blockquote>
            <figcaption>— Katarzyna W.</figcaption>
          </figure>
          <div id="kup" className="lp-hero-buy">
            <PriceBlock testid="price" note={NOTE_TOP} />
            <BuyButton testid="buy-button" />
            <p className="lp-trust" data-testid="trust-top">{TRUST}</p>
          </div>
        </section>

        {/* REVIEWS */}
        <section className="lp-section" data-testid="reviews">
          <h2 className="lp-h2">Co mówią czytelnicy</h2>
          <div className="lp-reviews">
            {TESTIMONIALS.map((t, i) => (
              <figure className="lp-review" key={i} data-testid={`review-${i}`}>
                <blockquote>„{t.t}”</blockquote>
                <figcaption>
                  <strong>{t.n}</strong>
                  <span>{t.m}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* PACKAGE */}
        <section className="lp-card" data-testid="offer-card">
          <h2 className="lp-card-h">Co dostajesz w pakiecie</h2>
          <ul className="lp-list">
            {PACKAGE.map((x, i) => (
              <li key={i}><Check size={20} /> <span>{x}</span></li>
            ))}
          </ul>
        </section>

        {/* AUTHOR */}
        <section className="lp-section lp-author" data-testid="author">
          <div className="lp-author-photo">
            <img
              src={IMAGES.author.src}
              onError={(e) => onImgErr(e, IMAGES.author.fb)}
              referrerPolicy="no-referrer"
              alt="Agnieszka Drożak"
            />
          </div>
          <div className="lp-author-txt">
            <h2 className="lp-h2">O autorce</h2>
            <p>
              Nazywam się <strong>Agnieszka Drożak</strong>. Jestem filologiem hiszpańskiego, od lat mieszkam w Hiszpanii i uczę Polaków prawdziwego, żywego hiszpańskiego. „Un nuevo comienzo” napisałam po to, żebyś mógł cieszyć się czytaniem po hiszpańsku już na poziomie A1/A2 — bez czekania, aż osiągniesz B2.
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section className="lp-section" data-testid="faq">
          <h2 className="lp-h2">Najczęstsze pytania</h2>
          <div className="lp-faq">
            {FAQ.map((f, i) => (
              <FaqItem key={i} q={f.q} a={f.a} i={i} />
            ))}
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="lp-final" data-testid="final-cta">
          <PriceBlock testid="price-bottom" note={NOTE_BOTTOM} />
          <BuyButton testid="buy-button-bottom" />
          <p className="lp-trust" data-testid="trust-bottom">{TRUST}</p>
        </section>

        <footer className="lp-footer">
          <p>Un nuevo comienzo · Agnieszka Drożak</p>
          <a href="mailto:info.agaespanol@gmail.com">info.agaespanol@gmail.com</a>
        </footer>
      </main>
    </div>
  );
}

export default App;
